import { ArrowUpIcon } from '@heroicons/react/24/outline';
import { IUserModel, Resolution } from '@packages/global';
import { useTranslation } from 'react-i18next';
import ModelSelector from '../ModelSelector';
import { CoinPriceDisplay } from '../../../../common/form';

interface ToolbarSectionProps {
  models: IUserModel[];
  modelId: string;
  selectedModel?: IUserModel;
  duration: number;
  resolution?: Resolution;
  isDisabled: boolean;
  isGenerating?: boolean;
  isSubmitDisabled?: boolean;
  modelsLoading: boolean;
  hasAudioButNotSupported: boolean;
  onModelChange: (modelId: string) => void;
  onDurationChange: (duration: number) => void;
  onSubmit: () => void;
}

export default function ToolbarSection({
  models,
  modelId,
  selectedModel,
  duration,
  resolution,
  isDisabled,
  isGenerating = false,
  isSubmitDisabled = false,
  modelsLoading,
  hasAudioButNotSupported,
  onModelChange,
  onDurationChange,
  onSubmit
}: ToolbarSectionProps) {
  const { t } = useTranslation('editor');
  const supportedDurations = selectedModel?.supportedDurations ?? [];
  const showDurationSelector = supportedDurations.length > 0;

  return (
    <div className="px-4 py-3">
      <div className="flex items-center justify-between">
        {/* 左侧工具按钮 */}
        <div className="flex items-center gap-2">
          <ModelSelector
            models={models}
            value={modelId}
            onChange={onModelChange}
            disabled={isDisabled}
            loading={modelsLoading}
          />

          {showDurationSelector && (
            <select
              value={duration}
              onChange={(e) => onDurationChange(Number(e.target.value))}
              disabled={isDisabled}
              className="px-2 py-1.5 bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm rounded-lg border border-gray-700 outline-none disabled:opacity-50 cursor-pointer w-16"
            >
              {supportedDurations.map(sec => (
                <option key={sec} value={sec}>{t('videoGenForm.durationSeconds', { sec })}</option>
              ))}
            </select>
          )}
        </div>

        {/* 右侧提交按钮 */}
        <div className="flex items-center gap-3">
          <CoinPriceDisplay modelId={modelId} duration={duration} resolution={resolution} />
          <button
            onClick={onSubmit}
            disabled={isSubmitDisabled || !modelId}
            className={`p-2 rounded-full transition-colors ${isSubmitDisabled || !modelId
              ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
              : 'bg-gray-600 hover:bg-gray-500 text-white'
              }`}
          >
            {isGenerating ? (
              <div className="h-5 w-5 border-2 border-gray-500 border-t-white rounded-full animate-spin" />
            ) : (
              <ArrowUpIcon className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
